import React from 'react';

const FadeElement: any = (props) => {
  const { children, ...transitionProps } = props;
  return <div {...transitionProps}>{children}</div>;
};

export default FadeElement;
